import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        // Extending the summTreeColumn filter for custom aggregation
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the filter display with aggregated values.
                 * @param {Object} master - The master data view.
                 * @param {Object} node - The node to update.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for aggregation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) {
                            // Aggregate only level 1 items
                            result += obj[value.columnId]; // Sum the specified column
                        }
                    });
                    // Format the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        if (value.columnId === 'Profitness') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node display
                },
            },
            webix.ui.datafilter.summColumn, // Extend from existing summColumn filter
        );
        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'treetable', // Treetable view
                            id: 'treetable', // Treetable ID
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de creación'), // Column header
                                    width: 260, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            // Check if the row is a group
                                            return (
                                                common.treetable(obj, common) + obj.value // Return group template
                                            );
                                        return obj.CreatedLocalDate; // Return creation date
                                    },
                                    format: dateFormat, // Date format
                                    fillspace: 0, // No fill space
                                    minWidth: 0, // Minimum width
                                    sort: 'text', // Sort type
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre Usuario'), // Column header
                                    width: 250, // Column width
                                    sort: 'string', // Sort type
                                    hidden: !devConfig.getPermAction(
                                        'sensitiveInformationNames',
                                        'Add', // Conditional visibility based on permissions
                                    ),
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header
                                    options: [
                                        // Dropdown options for state
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'LastLoginLocalDate', // Column ID
                                    header: _('Fecha del ultimo logueo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'NameAffiliate', // Column ID
                                    header: _('Nombre Afiliador'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'BetShopName', // Column ID
                                    header: _('Punto de Venta'), // Column header
                                    width: 150, // Column width
                                },
                            ],
                            on: {
                                /**
                                 * Event handler for double-clicking an item.
                                 * @param {String} id - The ID of the clicked item.
                                 */
                                onItemDblClick: (id) => {
                                    window.location.href = '#!/top/customers?user=' + id + '/information'; // Redirect to user information
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // API URL for data fetching
                            url: devConfig.geturlApi() + 'es/UserManagement/GetUsersAffiliates',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        grid = $$('treetable'); // Reference to the treetable
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // URL for data fetching
        var filter = ''; // Initialize filter string

        // Event handler for after data load
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                by: 'NameAffiliate', // Group data by NameAffiliate
                map: {
                    NameAffiliate: ['NameAffiliate'], // Mapping for grouping
                },
            });
        });

        // Event handler for filtering user affiliates
        this.on(this.app, 'userAffiliates:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filtering
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });
    }
}

// FILE DOCUMENTED
